import axios from 'axios';
import { HttpConstants } from 'constants/HttpConstants'

const api = () => {
  const instance = axios.create({ baseURL: '' });

  instance.interceptors.request.use(async (config) => {
    config.headers[HttpConstants.HEADER_CONTENT] = HttpConstants.TYPE_JSON;
    return config;
  });

  return instance;
};

export default api();